<div [hidden]="isEstimateLoading">
  <app-list-grid-client-side
    [rowData]="estimatedSecurityRegistryRecords"
    [colDefs]="$any(shareCancellationEstimatesColDefs)"
    [suppressRowClickSelection]="true"
    [paginationPageSize]="20"
    [paginationPageSizeSelector]="true"
    [suppressCellFocus]="true"
  />
</div>

<app-loader [loading]="isEstimateLoading"/>
